export default __webpack_public_path__ + "static/media/icon4.05333c97.png";